module.exports = __webpack_public_path__ + "static/media/agroempresalogo.626d4fd9.jpg";